<template>
  <div>
    <video-dashboard/>
  </div>
</template>

<script>
  import VideoDashboard from '@/components/VideoDashboard';

  export default {
    name: 'VideoDashboardCams',
    components: {
      VideoDashboard,
    },
  };
</script>

